import Vue from "vue";
import Router from "vue-router";
import { installRouteGuard } from "./utils/routeGuard";

import Login from "./views/Login.vue";
import NotFound from "./views/404.vue";
import NoPermission from "./views/403.vue";
import ServerError from "./views/500.vue";

import orderitem from "./views/index/orderitem";

import yhx from "./views/index/yhx";

import odds from "./views/index/odds";
import chakang from "./views/index/chakang";

import xiangqing from "./views/messagelist/xiangqing";

import list from "./views/managementhrough/list";

import manxiangq from "./views/managementhrough/manxiangq";

import meandxiao from "./views/managementhrough/meandxiao";

import ordass from "./views/index/ordass";

import hunshozjus from "./views/index/hunshozjus";

import statistarehouse from "./views/index/statistarehouse";
import detailbuy from "./views/shebei/detail.vue"; //设备详情-购买
import detaillease from "./views/shebei/detail_lease.vue"; //设备详情-租赁
import photoUploading from "./views/shebei/photoUploading.vue"; //证件上传
import filterEarlyDetail from "./views/shebei/filterEarly_detail.vue"; //滤芯余量预计详情
import shebeiPriceEdit from "./views/shebei/shebeiPriceEdit.vue"; //设备单价编辑
import homeShebeiDetail from "./views/shebei/homeShebeiDetail.vue"; //家用机设备详情

import enterpriseincomedetails from "./views/enterpriseincome/enterpriseincome_details.vue"; //企业收益详情
import earningsdetailsmonth from "./views/agentmanagement/earningsdetails_month.vue"; //代理商收益明细（月）
import earningsdetailsday from "./views/agentmanagement/earningsdetails_day.vue"; //代理商收益明细（日）
import agentdetails from "./views/agentmanagement/agentdetails.vue"; //代理商详情
import yanzhengma from "./views/yanzhengma.vue";
import roleAdd from "./views/sys/roleAdd.vue"; //角色新增
import roleEdit from "./views/sys/roleEdit.vue"; //角色编辑
import pay from "./views/communication/pay.vue"; //预警支付页面
import closeEarly from "./views/communication/closeEarly.vue"; //关闭预警设备列表
import top from "./views/SIM/top.vue"; //sim充值页面
import buy from "./views/SIM/buy.vue"; //sim购卡页面
import upgradeStatus from "./views/upgradeStatus.vue";

import receiverDetail from "./views/waterCard/receiverDetail.vue"; //转卡详情
import fenPeople from "./views/waterCard/fenPeople.vue"; //水卡分配员工

import Layout from "./views/Layout.vue"; //layout
import RouteView from "./components/RouteView.vue";

import cardOpen from "./views/waterCard/cardOpen.vue"; //水卡开通
import cardTop from "./views/waterCard/cardTop.vue"; //水卡充值
import cardDetail from "./views/waterCard/cardDetail.vue"; //水卡详情
import timeCard from "./views/waterCard/timeCard.vue"; //普通实物卡转时效实物卡

import cardTopPay from "./views/waterCard/cardTopPay.vue"; //水卡充值支付

// 分区
import zoneInfo from "./views/zoneManage/zoneInfo.vue"; //区域信息
import zoneShebei from "./views/zoneManage/zoneShebei.vue"; //分配设备
import control from "./views/zoneManage/control.vue"; //一键控制
import zoneCard from "./views/zoneManage/zoneCard.vue"; //分配水卡

// 合伙人权益管理
import partnerAdd from "./views/partner/partnerAdd.vue"; //合伙人编辑
import partnerDetail from "./views/partner/partnerDetail.vue"; //合伙人详情
import partnerApplyDetail from "./views/partner/partnerApplyDetail.vue"; //合伙人申请详情
import partnerMaintainerShareMoneyDetail from "./views/partner/partnerMaintainerShareMoneyDetail.vue"; //合伙人维护人分润详情
import spentDeatils_have from "./views/ordermanagement/spentDeatils_have.vue"; //合伙人申请详情

// 员工管理
import setRole from "./views/staff/setRole.vue"; //操作员工角色
import staffDetail from "./views/staff/staffDetail.vue"; //员工详情
import teamDetail from "./views/staff/teamDetail.vue"; //团队详情
import teamDetail1 from "./views/staff/teamDetail1.vue"; //绩效
import teamDetail1info from "./views/staff/teamDetail1info.vue"; //绩效info
import teamDetail2info from "./views/staff/teamDetail2info.vue"; //绩效info

import ClientDetail from "./views/client/clientDetail.vue"; //客户管理客户详情

import afterDetail from "./views/ordermanagement/afterDetail.vue"; //充值售后详情

import afterDetailVoucher from "./views/ordermanagement/afterDetailVoucher.vue"; //充值售后详情
import valueAddedService from "./views/valueAddedService/valueAddedService.vue"; //充值售后详情

// 物联网卡管理
import SIMDetail from "./views/SIM/SIMDetail.vue";

const constantRoutes = [
  // 水卡清零
  {
    path: "/cardClearZero",
    component: Layout,
    name: "水卡清零",
    redirect: "/cardClearZero/applyForRecord",
    children: [
      {
        path: "/cardClearZero/detail",
        component: () => import("./views/cardClearZero/detail.vue"),
        name: "申请详情"
      },
      {
        path: "/cardClearZero/huiFuDetail",
        component: () => import("./views/cardClearZero/huiFuDetail.vue"),
        name: "恢复详情"
      }
    ]
  },
  // 增值服务
  {
    path: "/valueAddedService",
    component: Layout,
    name: "增值服务",
    redirect: "/valueAddedService/valueAddedService",
    children: [
      {
        path: "/valueAddedService/valueAddedService",
        component: () =>
          import("./views/valueAddedService/valueAddedService.vue"),
        name: "产品列表"
      },
      {
        path: "/valueAddedService/orderHistory",
        component: () => import("./views/valueAddedService/orderHistory.vue"),
        name: "订单列表"
      },
      {
        path: "/valueAddedService/transferVoucher",
        component: () =>
          import("./views/valueAddedService/transferVoucher.vue"),
        name: "购买支付"
      }
    ]
  },
  // 分区管理
  {
    path: "/zoneManage",
    component: Layout,
    name: "分区管理",
    redirect: "/zoneManage/zoneIndex",
    children: [
      {
        path: "/zoneManage/zoneInfo",
        component: zoneInfo,
        name: "区域信息"
      },
      {
        path: "/zoneManage/zoneShebei",
        component: zoneShebei,
        name: "分配设备"
      },
      {
        path: "/zoneManage/control",
        component: control,
        name: "一键控制"
      },
      {
        path: "/zoneManage/zoneCard",
        component: zoneCard,
        name: "分配水卡"
      }
    ]
  },

  // 客户管理
  {
    path: "/client",
    component: Layout,
    name: "客户管理",
    redirect: "/client/clientList",
    children: [
      {
        path: "/client/clientList/clientDetail",
        component: ClientDetail,
        name: "客户详情"
      }
    ]
  },

  // 物联网卡管理
  {
    path: "/SIM",
    component: Layout,
    name: "SIM",
    redirect: "/SIM/SIMList",
    children: [
      {
        path: "/SIM/SIMList/SIMDetail",
        component: SIMDetail,
        name: "物联网卡详情"
      }
    ]
  },

  // 合伙人权益
  {
    path: "/partner",
    component: Layout,
    name: "合伙人权益",
    redirect: "/partner/partnerManage",
    children: [
      {
        path: "/partner/partnerManage/partnerAdd",
        component: partnerAdd,
        name: "编辑合伙人"
      },
      {
        path: "/partner/partnerManage/partnerDetail",
        component: partnerDetail,
        name: "合伙人详情"
      },
      {
        path: "/partner/partnerApply/partnerApplyDetail",
        component: partnerApplyDetail,
        name: "合伙人申请详情"
      },
      {
        path: "/partner/partnerApply/partnerMaintainerShareMoneyDetail",
        component: partnerMaintainerShareMoneyDetail,
        name: "合伙人维护人分润详情"
      }
    ]
  },
  // Ai应用
  {
    path: "/dataAnalysis",
    component: Layout,
    name: "AI应用",
    children: [
      {
        path: "/dataAnalysis/dataAnalysisRecord",
        component: () => import("./views/dataAnalysis/dataAnalysisRecord.vue"),
        name: "分析记录"
      },
      {
        path: "/dataAnalysis/dataAnalysisDetail",
        component: () => import("./views/dataAnalysis/dataAnalysisDetail.vue"),
        name: "分析详情"
      }
    ]
  },
  // 员工管理
  {
    path: "/staff",
    component: Layout,
    name: "员工管理",
    redirect: "/staff/staffRole",
    children: [
      {
        path: "/staff/staffRole/setRole",
        component: setRole,
        name: "角色编辑"
      },
      {
        path: "/staff/staffDetail",
        component: staffDetail,
        name: "员工详情"
      },
      {
        path: "/staff/sellTeam/teamDetail",
        component: teamDetail,
        name: "团队详情"
      },

      {
        path: "/staff/sellTeam/teamDetail1",
        component: teamDetail1,
        name: "员工绩效"
      },
      {
        path: "/staff/sellTeam/teamDetail1info",
        component: teamDetail1info,
        name: "员工绩效详情"
      },
      {
        path: "/staff/sellTeam/teamDetail2info",
        component: teamDetail2info,
        name: "员工绩效详情"
      },
      {
        path: "/staff/teamperformance/teamPerformanceAdd",
        component: () =>
          import("./views/teamperformance/teamPerformanceAdd.vue"),
        name: "新增团队"
      },
      {
        path: "/staff/teamperformance/teamPerformanceDetail",
        component: () =>
          import("./views/teamperformance/teamPerformanceDetail.vue"),
        name: "团队详情"
      },
      {
        path: "/staff/teamperformance/teamPerformancePersonDetail",
        component: () =>
          import("./views/teamperformance/teamPerformancePersonDetail.vue"),
        name: "员工个人详情"
      }
    ]
  },

  // 订单充值
  {
    path: "/ordermanagement",
    component: Layout,
    name: "订单管理",
    redirect: "/ordermanagement/details",
    children: [
      {
        path: "/ordermanagement/topAfter/afterDetail",
        component: afterDetail,
        name: "详情"
      },
      {
        path: "/ordermanagement/topAfter/afterDetailVoucher",
        component: afterDetailVoucher,
        name: "充值订单售后凭证"
      },
      {
        path: "/ordermanagement/details/spentDeatils_have",
        component: spentDeatils_have,
        name: "订单详情"
      }
    ]
  },

  {
    path: "/Login",
    component: Login,
    name: "登录",
    hidden: true
  },
  {
    path: "/upgradeStatus",
    component: upgradeStatus,
    name: "升级中",
    hidden: true
  },
  // 选择场景
  {
    path: "/sceneSelect",
    component: () => import("./views/sceneSelect.vue"),
    name: "选择场景",
    hidden: true
  },

  // 跳转中间页面
  {
    path: "/centerHtml",
    component: () => import("./views/centerHtml.vue"),
    name: "加载中",
    hidden: false
  },

  // 消息列表
  // {
  //   path: "/sys/news",
  //   component: () => import("./views/sys/news.vue"),
  //   name: "消息列表",
  //   hidden: true,
  // },

  // 消息列表
  {
    path: "/sys/news",
    component: Layout,
    name: "消息列表",
    children: [
      {
        path: "/sys/news",
        component: () => import("./views/sys/news.vue"),
        hidden: true
      }
    ],
    hidden: true
  },

  // 个人中心
  {
    path: "/personage/detail",
    component: Layout,
    name: "个人中心",
    children: [
      {
        path: "/personage/detail",
        component: () => import("./views/personage/detail.vue"),
        hidden: true
      }
    ],
    hidden: true
  },

  // 角色新增
  {
    path: "/sys",
    component: Layout,
    name: "系统管理",
    redirect: "/sys/role",
    children: [
      {
        path: "/sys/role/roleAdd",
        component: roleAdd,
        name: "新增角色"
      },
      {
        path: "/sys/role/roleEdit",
        component: roleEdit,
        name: "编辑角色"
      }
    ]
  },

  // 水卡管理
  {
    path: "/waterCard",
    component: Layout,
    name: "水卡管理",
    redirect: "/waterCard/cardList",
    children: [
      {
        path: "/waterCard/cardList/cardOpen",
        component: cardOpen,
        name: "水卡开通"
      },
      {
        path: "/waterCard/cardList/cardTop",
        component: cardTop,
        name: "水卡充值"
      },
      {
        path: "/waterCard/cardList/cardDetail",
        component: cardDetail,
        name: "水卡详情"
      },
      {
        path: "/waterCard/cardList/timeCard",
        component: timeCard,
        name: "实物卡转换"
      },
      {
        path: "/waterCard/cardList/cardTop/cardTopPay",
        component: cardTopPay,
        name: "充值支付"
      },
      {
        path: "/waterCard/receiverDetail",
        component: receiverDetail,
        name: "转卡详情"
      },
      {
        path: "/waterCard/cardList/fenPeople",
        component: fenPeople,
        name: "分配员工"
      }
    ]
  },

  // 通信预警服务
  {
    path: "/communication",
    component: Layout,
    name: "通信预警服务",
    redirect: "/communication/communicationSet",
    children: [
      {
        path: "/communication/communicationSet/pay",
        component: pay,
        name: "套餐支付"
      },
      {
        path: "/communication/communicationSet/closeEarly",
        component: closeEarly,
        name: "关闭预警设备列表"
      }
    ]
  },

  // sim卡管理
  {
    path: "/SIM",
    component: Layout,
    name: "SIM卡管理",
    redirect: "/SIM/SIMList",
    children: [
      {
        path: "/SIM/SIMList/top",
        component: top,
        name: "SIM卡充值"
      },
      {
        path: "/SIM/SIMList/buy",
        component: buy,
        name: "SIM卡购买"
      }
    ]
  },

  {
    path: "/getCode",
    component: () => import("./views/getCode.vue"),
    name: "getCode",
    hidden: true
  },

  {
    path: "/resetPassword",
    component: () => import("./views/resetPassword.vue"),
    name: "resetPassword",
    hidden: true
  },

  {
    path: "/yanzhengma",
    component: yanzhengma,
    name: "验证码登录",
    hidden: true
  },
  {
    path: "/404",
    component: NotFound,
    name: "Error",
    hidden: true
  },
  {
    path: "/403",
    component: NoPermission,
    name: "NoPermission",
    hidden: true
  },
  {
    path: "/500",
    component: ServerError,
    name: "ServerError",
    hidden: true
  },
  {
    path: "/",
    component: Layout,
    hidden: true
  },

  {
    path: "/index",
    component: Layout,
    name: "系统首页",
    iconCls: "fa fa-id-card-o",
    children: [
      { path: "/index/orderitem", component: orderitem, name: "订单详情" },
      { path: "/index/ordass", component: ordass, name: "订单详情" },
      { path: "/index/yhx", component: yhx, name: "订单详情" },
      { path: "/index/odds", component: odds, name: "业务详情" },
      { path: "/index/chakang", component: chakang, name: "业务详情" },
      {
        path: "/index/statistarehouse",
        component: statistarehouse,
        name: "运营"
      },
      { path: "/index/hunshozjus", component: hunshozjus, name: "拒收" }
    ]
  },
  //设备详情
  {
    path: "/shebei",
    component: Layout,
    redirect: "/shebei/shebeilist",
    name: "设备管理",
    children: [
      {
        path: "/shebei/filterEarly/datail",
        component: filterEarlyDetail,
        name: "滤芯余量预警详情"
      },
      {
        path: "/shebei/shebeiPriceEdit",
        component: shebeiPriceEdit,
        name: "单价编辑"
      },
      {
        path: "/homeShebeilist/homeShebeiDetail",
        component: homeShebeiDetail,
        name: "设备详情"
      },
      {
        path: "/shebei/shebeilist/detail",
        component: detailbuy,
        name: "设备详情"
      },
      {
        path: "/shebei/photoUploading",
        component: photoUploading,
        name: "证件上传"
      },
      {
        path: "/shebei/shebeilist/detaillease",
        component: detaillease,
        name: "设备详情-租赁"
      }
    ]
  },
  // 企业收益详情
  {
    path: "/enterpriseincome",
    component: Layout,
    redirect: "/enterpriseincome/enterpriseincome",
    name: "企业收益",
    children: [
      {
        path: "/enterpriseincome/enterpriseincome/details",
        component: enterpriseincomedetails,
        name: "企业收益详情"
      }
    ]
  },
  // 代理商管理
  {
    path: "/agentmanagement",
    component: Layout,
    redirect: "/agentmanagement/agent_lists",
    name: "代理商管理",
    children: [
      {
        path: "/agentmanagement/agent_earnings/details_month",
        component: earningsdetailsmonth,
        name: "收益详情"
      },
      {
        path: "/agentmanagement/agent_earnings/details_day",
        component: earningsdetailsday,
        name: "收益详情"
      },
      {
        path: "/agentmanagement/agent_lists/details_details",
        component: agentdetails,
        name: "代理商详情"
      }
    ]
  },

  {
    path: "/personal",
    component: Layout,
    name: "personal",
    iconCls: "fa fa-id-card-o",
    children: []
  },

  {
    path: "/managementhrough",
    component: Layout,
    name: "系统首页",
    iconCls: "fa fa-id-card-o",
    children: [
      {
        path: "/managementhrough/manxiangq",
        component: manxiangq,
        name: "物流详情"
      },

      {
        path: "/managementhrough/meandxiao",
        component: meandxiao,
        name: "详情"
      },

      { path: "/managementhrough/list", component: list, name: "物流详情" }
    ]
  },

  {
    path: "/messagelist",
    component: Layout,
    name: "messagelist",
    iconCls: "fa fa-id-card-o",
    children: [
      {
        path: "/messagelist/xiangqing",
        component: xiangqing,
        name: "物流详情"
      }
    ]
  },
  // {
  //   path: '/activityOrder',
  //   component: () =>
  //     import('./views/order/goodsOrder.vue'),
  //   hidden: true,
  // }
  // {
  //     path: '/',
  //     component: () =>
  //         import ('@/views/layout'),
  //     name: '主页',
  //     iconCls: 'el-icon-message', //图标样式class
  //     leaf: true, //只有一个节点
  //     children: [
  //         { path: '/', component: Main, name: '主页' },
  //     ]
  // },
  // {
  //     path: '/nav1',
  //     component: Layout,
  //     name: '导航一',
  //     iconCls: 'el-icon-message', //图标样式class
  //     children: [
  //         { path: '/nav1/table', component: Table, name: 'Table' },
  //         { path: '/nav1/form', component: Form, name: 'Form' },
  //         { path: '/nav1/user', component: user, name: '列表' },
  //     ]
  // },
  // {
  //     path: '/sys',
  //     component: Layout,
  //     name: '系统管理',
  //     iconCls: 'fa fa-id-card-o',
  //     children: [
  //         { path: '/sys/menu', component: menu, name: '菜单管理' },
  //         { path: '/sys/button', component: button, name: '按钮管理' },
  //         { path: '/sys/interface', component: interf, name: '接口列表' },
  //         { path: '/sys/role', component: role, name: '角色管理' },
  //         { path: '/sys/rolep', component: Page5, name: '权限管理' },
  //         { path: '/sys/user', component: Page5, name: '用户管理' }
  //     ]
  // },
  //   {
  //   path: '/nav3',
  //   component: Layout,
  //   name: '导航伞三',
  //   iconCls: 'fa fa-address-card',
  //   leaf: true, //只有一个节点
  //   children: [
  //     { path: '/nav3/page6', component: Page6, name: '导航三' }
  //   ]
  // },
  // {
  //     path: '/charts',
  //     component: Layout,
  //     name: 'Charts',
  //     iconCls: 'fa fa-bar-chart',
  //     children: [
  //         { path: '/charts/echarts', component: echarts, name: 'echarts' }
  //     ]
  // }
  {
    path: "/inventory",
    component: Layout,
    name: "库存管理",
    iconCls: "fa fa-id-card-o",
    children: [
      {
        path: "/inventory/stockTakingDetail",
        component: () => import("./views/inventory/stockTakingDetail.vue"),
        name: "库存盘点详情"
      }
    ]
  },
  {
    path: "/recycle",
    component: Layout,
    name: "回收站管理",
    iconCls: "fa fa-id-card-o",
    children: [
      {
        path: "/inventory/recycleListDetail",
        component: () => import("./views/recycle/recycleListDetail.vue"),
        name: "回收站详情"
      }
    ]
  }
];

// add route path
constantRoutes.forEach(route => {
  route.path = route.path || "/" + (route.name || "");
});

Vue.use(Router);
function createRouter(routeRecords) {
  return new Router({ routes: routeRecords });
}

const router = createRouter(constantRoutes);

// router.js 仅声明静态配置；鉴权、动态菜单路由及守卫由 utils 统一安装。
installRouteGuard(router, {
  constantRoutes,
  createRouter,
  layoutComponent: Layout,
  routeViewComponent: RouteView,
  notFoundComponent: NotFound,
});

export { router };
